// Adapted from
// https://github.com/streamich/react-use/blob/823f94f32190fe6728a829cfd895744f02878e66/src/useToggle.ts
import { useCallback, useState } from "react";

export const useToggle = (initialValue: boolean): [boolean, (nextValue?: boolean) => void] => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const [value, setValue] = useState<boolean>(initialValue);

  const toggle = useCallback(
    (nextValue?: boolean) => {
      if (typeof nextValue === "boolean") {
        setValue(nextValue);
      } else {
        setValue((currentValue) => !currentValue);
      }
    },
    [setValue]
  );

  return [value, toggle];
};
